var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgStoreCheck = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M14 19.9102H21",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M19.7798 9.77979V19.9098",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M4.30107 9.778C2.60307 9.766 1.49607 8.085 2.23207 6.636L3.94807 3.259C4.33807 2.489 5.16007 2 6.06207 2H17.9381C18.8401 2 19.6621 2.489 20.0531 3.259L21.7691 6.636C22.5051 8.085 21.3981 9.766 19.7001 9.778C18.2831 9.778 17.1341 8.81 17.1341 7.615V7.567C17.1341 8.788 15.9851 9.778 14.5681 9.778C13.1491 9.778 12.0001 8.788 12.0001 7.567C12.0001 8.788 10.8511 9.778 9.43407 9.778C8.01707 9.778 6.86807 8.788 6.86807 7.567V7.615C6.86707 8.81 5.71807 9.778 4.30107 9.778V9.778Z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M7.9011 16.7998L6.1511 18.5498L5.1001 17.4998",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M2.24799 18.2319L2.84599 19.0139L2.97499 19.9869C3.04699 20.5269 3.47099 20.9519 4.01099 21.0239L4.98699 21.1539L5.76799 21.7509C6.19999 22.0809 6.79999 22.0819 7.23299 21.7509L8.01499 21.1539H8.01399L8.98799 21.0249C9.52799 20.9529 9.95299 20.5289 10.025 19.9889L10.155 19.0129C10.155 19.0129 10.457 18.6179 10.753 18.2319C11.083 17.7999 11.083 17.1999 10.753 16.7679L10.155 15.9859L10.026 15.0129C9.95399 14.4729 9.52999 14.0479 8.98999 13.9759L8.01399 13.8459L7.23299 13.2489C6.80099 12.9189 6.20099 12.9179 5.76799 13.2489L4.98599 13.8459H4.98699L4.01299 13.9749C3.47299 14.0469 3.04799 14.4709 2.97599 15.0109L2.84599 15.9869C2.84599 15.9869 2.54399 16.3819 2.24799 16.7679C1.91799 17.1999 1.91799 17.7999 2.24799 18.2319V18.2319Z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStoreCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/store-check.6af1316a.svg";
export { ForwardRef as ReactComponent };